import { List } from "immutable";

export function priorityFilter<T>(
  values: List<T>,
  filters: Array<(element: T) => boolean>
) {
  let vals = List([...values]); // NOTE: this fails without downlevelIteration set

  for (let i = 0; i < filters.length; i++) {
    const valuesBeforeFilter = vals;
    vals = vals.filter(filters[i]);
    if (vals.size === 0) return valuesBeforeFilter;
  }

  return vals;
}
